/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Storypage_TitleInputs */

const en_fw_storypage_title = /** @type {(inputs: Fw_Storypage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The story of Firefly Wedding`)
};

const zh_fw_storypage_title = /** @type {(inputs: Fw_Storypage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁的故事`)
};

/**
* | output |
* | --- |
* | "The story of Firefly Wedding" |
*
* @param {Fw_Storypage_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_storypage_title = /** @type {((inputs?: Fw_Storypage_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Storypage_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_storypage_title(inputs)
	return zh_fw_storypage_title(inputs)
});
export { fw_storypage_title as "fw.storypage.title" }